"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var local_storage_events_1 = require("./local-storage-events");

var react_1 = require("react");

function tryParse(value) {
  try {
    return JSON.parse(value);
  } catch (_a) {
    return value;
  }
}

function useLocalStorage(key, initialValue) {
  var _react_1$useState = react_1.useState(localStorage.getItem(key) === null ? initialValue : tryParse(localStorage.getItem(key))),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      localState = _react_1$useState2[0],
      updateLocalState = _react_1$useState2[1];

  var onLocalStorageChange = function onLocalStorageChange(event) {
    if (local_storage_events_1.isTypeOfLocalStorageChanged(event)) {
      if (event.detail.key === key) {
        updateLocalState(event.detail.value);
      }
    } else {
      if (event.key === key) {
        if (event.newValue) {
          updateLocalState(tryParse(event.newValue));
        }
      }
    }
  }; // when the key changes, update localState to reflect it.


  react_1.useEffect(function () {
    updateLocalState(localStorage.getItem(key) === null ? initialValue : tryParse(localStorage.getItem(key)));
  }, [key]);
  react_1.useEffect(function () {
    // The custom storage event allows us to update our component
    // when a change occurs in localStorage outside of our component
    var listener = function listener(e) {
      return onLocalStorageChange(e);
    };

    window.addEventListener(local_storage_events_1.LocalStorageChanged.eventName, listener); // The storage event only works in the context of other documents (eg. other browser tabs)

    window.addEventListener('storage', listener);
    var canWrite = localStorage.getItem(key) === null; // Write initial value to the local storage if it's not present or contains invalid JSON data.

    if (initialValue !== undefined && canWrite) {
      local_storage_events_1.writeStorage(key, initialValue);
    }

    return function () {
      window.removeEventListener(local_storage_events_1.LocalStorageChanged.eventName, listener);
      window.removeEventListener('storage', listener);
    };
  }, [key]);
  var writeState = react_1.useCallback(function (value) {
    return local_storage_events_1.writeStorage(key, value);
  }, [key]);
  var deleteState = react_1.useCallback(function () {
    return local_storage_events_1.deleteFromStorage(key);
  }, [key]);
  return [localState === null ? initialValue : localState, writeState, deleteState];
}

exports.useLocalStorage = useLocalStorage;